var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config && _vm.config.LOGIN_SERVICE_URL)?_c('iframe',{staticStyle:{"width":"0","height":"0","border":"0","position":"absolute"},attrs:{"src":((_vm.config.LOGIN_SERVICE_URL) + "/heartbeat")}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }